export interface AuthUser {
    token?: string;
    entity?: number | string;
    firstname?: string;
    lastname?: string;
    email?: string;
    login?: string;
    userinfo?: any[];
    [key: string]: any;
}

/**
 * Safely reads the authenticated user from localStorage.
 * Returns null if the entry is missing or malformed.
 * Clears the corrupted value to avoid infinite error loops.
 */
export const getAuthUser = (): AuthUser | null => {
    const raw = localStorage.getItem("authUser");
    if (!raw) return null;
    try {
        return JSON.parse(raw) as AuthUser;
    } catch {
        localStorage.removeItem("authUser");
        return null;
    }
};

/**
 * Returns the bearer token from localStorage, or null if not present.
 */
export const getAuthToken = (): string | null => {
    const user = getAuthUser();
    return user?.token ?? null;
};

/**
 * React hook exposing the current auth token and full user payload.
 * Note: this reads from localStorage on each call - fine for pages that
 * only need the token at fetch time.
 */
const useAuthToken = (): { token: string | null; user: AuthUser | null } => {
    const user = getAuthUser();
    return { token: user?.token ?? null, user };
};

export default useAuthToken;
